import React, { useState, useEffect } from 'react'
import styled from 'styled-components'
import { Box, Button } from "grommet"

const BoldButton = styled(Button)`
  font-weight: bold;
  font-size: 12px;
`;

export const StatusCount = ({ label, status }) => {

    const [background, setbackground] = useState('dark-5')
    const [color, setcolor] = useState('light-3')

    useEffect(() => {
        if (status === 'up') {
            setbackground('light-2')
            setcolor('ttok')
        } else if (status === 'down') {
            setbackground('ttdown')
            setcolor('white')
        } else if (status === 'partial') {
            setbackground('ttpartial')
            setcolor("dark-3")
        } else if (status === 'ase_pending_cleanup') {
            setbackground('light-2')
            setcolor("#8B008B")
        }
    }, [status])

    return (
        <Box overflow="hidden" background={background} round="xsmall" margin={{ left: "1.5px", right: "1.5px" }}>
            <BoldButton
                margin={{ left: "3px", right: "3px" }}
                plain
                color={color}
                size="small"
                label={label}
            />
        </Box>
    )
}

export default StatusCount